import { DashboardCardWrapper } from '../../../components/DashboardCardWrapper/dashboard-card-wrapper';
import { DashboardCardContentValue } from '../../../components/DashboardCardContentValue/dashboard-card-content-value';
import { useTranslation } from 'react-i18next';
import { VacancyListCard } from '../index';
import { BarChart } from '../../../components';
import { ReportingPaths } from '../../../../reporting/reporting.router';
import { usePostVacancyDashboardMutation } from '@client/api';
import { useDashboardFilters } from '../../../context/dashboard-filters.context';
import { useEffect } from 'react';
import { toCurrencyString, CurrencyCode } from '@client/toolkit';

export const VacancyCostWidget = () => {
  const { t } = useTranslation('widget');
  const { selectedSpaceIds, selectedDateFrom, selectedDateTo } = useDashboardFilters();

  const [trigger, { data, isLoading }] = usePostVacancyDashboardMutation();

  useEffect(() => {
    if (!selectedDateFrom || !selectedDateTo) return;
    trigger({
      startDate: selectedDateFrom,
      endDate: selectedDateTo,
      body: { buildingIds: selectedSpaceIds },
    });
  }, [selectedSpaceIds, selectedDateFrom, selectedDateTo, trigger]);

  const chartData = (data?.monthlyVacancyCosts ?? []).map((m) => ({
    month: m.month,
    value: m.cost.value,
  }));

  const totalFormatted = toCurrencyString(data?.totalVacancyCost.value ?? 0, undefined, {
    currency: (data?.totalVacancyCost.currency ?? 'NOK') as CurrencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return (
    <DashboardCardWrapper title={t('vacancyCost.title')} to={ReportingPaths.VacancyCost} loading={isLoading || !data}>
      <div className="grid grid-cols-2 gap-2">
        <div>
          <DashboardCardContentValue value={totalFormatted} />
          <div className="w-full h-80 py-8">
            <BarChart
              data={chartData}
              indexBy="month"
              keys={['value']}
              colors={'#EE7070'}
              axisBottom={{
                tickSize: 0,
                tickPadding: 10,
                legend: 'Måneder',
                legendOffset: 45,
                legendPosition: 'middle',
              }}
            />
          </div>
        </div>
        <VacancyListCard topBuildings={data?.topBuildings ?? []} />
      </div>
    </DashboardCardWrapper>
  );
};
